module.exports = __webpack_public_path__ + "img/tasa-febrero.8509e45c.png";